import { asyncAction, actionCreators } from 'lib/actionCreators'

export const addAvatar = asyncAction('profile/ADD_AVATAR')
export const addAvatarProgress = actionCreators('profile/ADD_AVATAR_PROGRESS')
